import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "File"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M20.8086 9.12837H3.19178C2.60324 9.12837 2.18266 9.69575 2.25152 10.3867L3.65416 18.8356C3.70403 19.3355 4.14293 19.7364 4.63505 19.7364H19.3653C19.8574 19.7364 20.2964 19.3355 20.3462 18.8356L21.7488 10.3867C21.8177 9.69575 21.3972 9.12837 20.8086 9.12837ZM18.9036 6.09126H10.4329L9.04093 4.26367H5.13516C4.54657 4.26367 4.06949 4.74085 4.06949 5.32939V6.87361H19.9309C19.8068 6.42259 19.394 6.09126 18.9036 6.09126ZM20.8966 8.63528L20.9477 8.17141H3.0527L3.10376 8.63528H20.8966ZM20.5245 7.77086L20.5911 7.28953H3.40929L3.47584 7.77086H20.5245Z",
  fill: "#DCE1E3"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var file = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { file as default };
